import React from "react";

export default function PopupFooter(props) {

  const isRight = props.right ? "footer-right" : "";

  return(
    <div className={`popup-fixed-footer ${isRight}`}>
      {props.children}
    </div>
  );
}